// Debug-mode flag, kept apart from debug.js so the app entries can check it
// without bundling the whole dashboard: debug.js is loaded with import() only
// when this is true, so regular visitors never download it.
//
// Active automatically during `yarn encore dev`. On any other build (incl. the
// deployed dev/staging host, which runs a production-mode build) opt in at
// runtime with either `?debug=1` in the URL or `localStorage.setItem('sb_debug', '1')`
// — no rebuild needed. Disable again with `localStorage.removeItem('sb_debug')`.
function isDebugMode() {
    if (typeof window === 'undefined') return false;
    if (process.env.NODE_ENV !== 'production') return true;
    try {
        if (new URLSearchParams(window.location.search).has('debug')) return true;
        return window.localStorage.getItem('sb_debug') === '1';
    } catch (e) {
        return false;
    }
}

export const debugMode = isDebugMode();

// The shared dev hosts (*.d.simplybook.ovh) run a production-mode build, so
// NODE_ENV can't tell them apart from prod — the hostname is the only signal.
function isDevHost() {
    if (typeof window === 'undefined') return false;
    var host = window.location.hostname;
    return host === 'localhost' || /\.d\.simplybook\.ovh$/.test(host);
}

export const devHost = isDevHost();

// Diagnostic console.log for dev hosts and debug mode only — production
// visitors must not see internal init chatter in their console. Use it for
// "what ran when" traces; keep real failures on console.warn/error.
export function debugLog() {
    if (!debugMode && !devHost) return;
    console.log.apply(console, arguments);
}
